"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chunkify = void 0;
function chunkify(arr, chunk) {
    var input = __spreadArray([], arr, true);
    var chunks = [];
    for (var i = 0; i < input.length; i += chunk) {
        chunks.push(input.slice(i, i + chunk));
    }
    return chunks;
}
exports.chunkify = chunkify;
//# sourceMappingURL=chunkify.js.map